import { ANALYTICS_BLACKLIST_DOMAINS } from './constants';
import NewsfeedApi from './api/NewsfeedApi';
import TagsApi from './api/TagsApi';
import TasksApi from './api/TasksApi';
import StatusApi from './api/StatusApi';
import DayPartsApi from './api/DayPartsApi';
import ConversationsApi from './api/ConversationsApi';
import ShiftTasksApi from './api/ShiftTasksApi';
import SelfInviteApi from './api/SelfInviteApi';
import UnavailabilityApi from './api/UnavailabilityApi';
import MessagesApi from './api/MessagesApi';
import TimeclockApi from './api/TimeclockApi';

export default class SlingApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;

    const apiMethods = { httpGet, httpPost, httpPut, httpDelete };
    const apis = {
      newsfeedApi: new NewsfeedApi(apiMethods),
      tagsApi: new TagsApi(apiMethods),
      tasksApi: new TasksApi(apiMethods),
      statusApi: new StatusApi(apiMethods),
      dayPartsApi: new DayPartsApi(apiMethods),
      conversationsPartsApi: new ConversationsApi(apiMethods),
      shiftTasksApi: new ShiftTasksApi(apiMethods),
      selfInviteApi: new SelfInviteApi(apiMethods),
      unavailabilityApi: new UnavailabilityApi(apiMethods),
      messagesApi: new MessagesApi(apiMethods),
      timeclockApi: new TimeclockApi(apiMethods),
    };

    Object.keys(apis).forEach((apiKey) => {
      this._rewriteMethods(apis[apiKey]);
    });
  }

  _rewriteMethods(api) {
    Object.getOwnPropertyNames(Object.getPrototypeOf(api)).forEach((method) => {
      this[method] = api[method];
    });
  }

  analyticsTrack(url, eventData, params = {}, httpConfig = {}) {
    const { type, value, orgId, toastRestaurantGuids, user } = eventData;
    const isBlockedDomain =
      user.email && ANALYTICS_BLACKLIST_DOMAINS.some((domain) => user.email.indexOf(domain) >= 0);

    if (isBlockedDomain) {
      return null;
    }

    const body = {
      org_id: orgId,
      user_id: user.id,
      toast_restaurant_guids: toastRestaurantGuids,
      type,
      value,
    };
    return this.httpPost(url, body, params, Object.assign({}, httpConfig, { noPrefix: true }));
  }

  getLaborSchema(params) {
    return this.httpGet('labor/schema', params);
  }
}
